<app-base-template (modal)="openModal(content)"(dataExportToExcel)="exportToExcel()"   (searchmodal) = "searchModal()"(tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [showExportBtn]="showExportBtn" [showSearch]="showSearch" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Process Area</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="processArea"
             placeholder="Enter Process area" >
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="desc"
             placeholder="Enter Desctiption" >
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="sequence"
             placeholder="Enter Sequence number greater than 0 " >
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Process Area "
                 [(ngModel)]="areaSelected">
      </div>
 </div>
  <div class="modal-footer pad-8">
     
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    

  </div>
<notifier-container></notifier-container>

